import { render, staticRenderFns } from "./WorkspaceCanvas.vue?vue&type=template&id=7f85ec4a&scoped=true"
import script from "./WorkspaceCanvas.vue?vue&type=script&lang=js"
export * from "./WorkspaceCanvas.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceCanvas.vue?vue&type=style&index=0&id=7f85ec4a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f85ec4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f85ec4a')) {
      api.createRecord('7f85ec4a', component.options)
    } else {
      api.reload('7f85ec4a', component.options)
    }
    module.hot.accept("./WorkspaceCanvas.vue?vue&type=template&id=7f85ec4a&scoped=true", function () {
      api.rerender('7f85ec4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceCanvas.vue"
export default component.exports